export class PostNotificationEmailRequestDto {
    to: string;
    notificationId: string;
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/models/PostNotificationEmailRequestDto.ts